package ro.horatiu_udrea.resursedeblocat

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.PrimaryTabRow
import androidx.compose.material3.Tab
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import org.jetbrains.compose.resources.stringResource
import resursedeblocat.composeapp.generated.resources.Res
import resursedeblocat.composeapp.generated.resources.tab_admin
import resursedeblocat.composeapp.generated.resources.tab_resources
import resursedeblocat.composeapp.generated.resources.tab_tracking

enum class HomeTab {
    RESOURCES, TRACKING, ADMIN
}

@Composable
fun HomeTabSelector(
    selectedTab: HomeTab,
    onTabSelected: (HomeTab) -> Unit,
    showAdmin: Boolean = false
) {
    PrimaryTabRow(
        selectedTabIndex = selectedTab.ordinal,
        containerColor = MaterialTheme.colorScheme.background,
        contentColor = MaterialTheme.colorScheme.primary
    ) {
        Tab(
            selected = selectedTab == HomeTab.RESOURCES,
            onClick = { onTabSelected(HomeTab.RESOURCES) },
            text = { Text(stringResource(Res.string.tab_resources)) }
        )
        Tab(
            selected = selectedTab == HomeTab.TRACKING,
            onClick = { onTabSelected(HomeTab.TRACKING) },
            text = { Text(stringResource(Res.string.tab_tracking)) }
        )
        if (showAdmin) {
            Tab(
                selected = selectedTab == HomeTab.ADMIN,
                onClick = { onTabSelected(HomeTab.ADMIN) },
                text = { Text(stringResource(Res.string.tab_admin)) }
            )
        }
    }
}
